import ClipButton from "@nkr/components/clip-button"
import {edit} from 'react-icons-kit/fa/edit'
import { IWatrFraudFlag } from "@nkr/models/watr-fraud-flag"
import { Button, Glyphicon, Label, Overlay, OverlayTrigger, Popover } from "react-bootstrap"
import Icon from "react-icons-kit"

interface IProps {
    flags: IWatrFraudFlag[]
    onLookup: (flag: IWatrFraudFlag) => void
}

const FraudFlagPopover = ({flags, onLookup}: IProps) => {
    
    const tip = (
        <Popover title="Possible Bank Error(s)">
            {flags.map(f => <p>
                {f.description} 
                <br /> 
                <span onClick={() => onLookup(f)} title="Open Related Request" style={{color: 'blue', cursor: 'pointer'}}>
                    <Icon icon={edit} /> Open Related Request
                </span>
                </p>)}
        </Popover>
    );
    
    return (
        <OverlayTrigger trigger={['focus']} placement="right" overlay={tip}>
            <Button bsSize="xsmall" bsStyle="danger"><Glyphicon glyph='flag' /></Button>
        </OverlayTrigger>
    );
}

export default FraudFlagPopover